import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=1c2e0a3c&scoped=true"
var script = {}
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=1c2e0a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e0a3c",
  null
  
)

export default component.exports